import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    initialState: {
        selectedIndex: 0
    },
    name: 'withSplitView',
    reducers: {
        setSelectedIndex: (state, action) => {
            state.selectedIndex = action.payload as number;
        }
    }
});

export default slice.reducer;
